<template>
  <div class="activity" :class="questTypeClassBackground(quest.type)" @click="loadActivity">
    <div class="icon-container d-flex align-items-center justify-content-center"
         :class="questTypeClassBackground(quest.type)">
      <SymbolIcon :iconName="quest.type" :color="'white'" :hoverName="PrettyName[quest.type]"></SymbolIcon>

    </div>
    <div class="title">
      <span v-if="isSimpleMode">
        {{ questTypeToString(quest.type) }}
      </span>
      <span v-else>
        {{ quest.title }}
      </span>
    </div>
    <div class="score d-flex align-items-center justify-content-center">
      {{ quest.points }}&nbsp;<BatteryLogo/>
    </div>
  </div>
</template>

<script>
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import { QuestTypeEnum } from "sandpiper_api";

import BatteryLogo from "@/assets/image/icons/quest/icon-activity_points.svg?inline";
import SymbolIcon from "@/components/UI/SymbolIcon.vue";
import {PrettyName} from "@/enums/PrettyName";

const QUEST_TYPE = new QuestTypeEnum();

export default {
  name: "QuestSelectedButton",
  components: {SymbolIcon, BatteryLogo},
  mixins: [ QuestTypeHelper ],
  props: {
    quest: Object,
  },
  computed: {
    PrettyName() {
      return PrettyName
    },
    isSimpleMode()
    {
      return this.quest.type === QUEST_TYPE.impulse;
    }
  },
  methods: {
    loadActivity()
    {
      this.$router.push({
        name: "quests", params: {}
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.activity
{
  border-radius: 5px;
  box-shadow: $default-shadow;
  height: 50px;
  margin-bottom: 0.66rem;
  cursor: pointer;
  color: $font-light;

  display: flex;

  .icon-container
  {
    min-width: 50px;
    overflow: visible;

    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;

    svg
    {
      fill: $font-light;
    }
  }

  .title
  {
    padding: 10px;
    flex: 1 1;

    display: flex;
    flex-direction: row;

    justify-content: flex-start;
    align-items: center;

    font-size: 0.875rem;
    font-weight: 500;

    min-width: 0; // To make the ellipsis work https://css-tricks.com/flexbox-truncated-text/

    span
    {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }

    .timestamp
    {
      color: $primary-blue;
      font-style: italic;
      font-weight: 400;
    }
  }

  .score
  {
    margin-right: 10px;

    svg
    {
      fill: $font-light;
    }
  }
}
</style>